import React, { useCallback } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const AwardBannersCarousel = () => {
  const banners = [
    {
      url: 'https://customer-assets.emergentagent.com/job_extension-academy/artifacts/7j4pnr7n_YES%20I%20WANT%20TO%20ENROL_20250913_202151_0005.png',
      alt: 'Award Banner - Finalist 2026'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_extension-academy/artifacts/4v6xf2tb_YES%20I%20WANT%20TO%20ENROL_20250913_202151_0004.png',
      alt: 'Award Banner - Winner 2025'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_extension-academy/artifacts/j4ldfd4m_YES%20I%20WANT%20TO%20ENROL_20250913_202151_0003.png',
      alt: 'Award Banner - Finalist 2025'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_extension-academy/artifacts/uuszf9db_YES%20I%20WANT%20TO%20reserve%20my%20region%20needahairmakeover.gif',
      alt: 'Reserve Your Region - Franchise Opportunity'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_extension-academy/artifacts/lc7nsblk_YES%20I%20WANT%20TO%20ENROL_20250913_202150_0000.png',
      alt: 'Award Banner - Finalist'
    }
  ];

  const [emblaRef, emblaApi] = useEmblaCarousel(
    { 
      loop: true, 
      align: 'center',
      slidesToScroll: 1
    },
    [Autoplay({ delay: 4000, stopOnInteraction: false })]
  );

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  return (
    <div className="award-banners-carousel-container">
      <div className="award-banners-embla" ref={emblaRef}>
        <div className="award-banners-embla__container">
          {banners.map((banner, index) => (
            <div className="award-banners-embla__slide" key={index}>
              <div className="award-banner-card">
                <img
                  src={banner.url}
                  alt={banner.alt}
                  className="award-banner-image"
                  loading={index < 2 ? 'eager' : 'lazy'}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <button
        className="award-banners-button award-banners-button-prev"
        onClick={scrollPrev}
        aria-label="Previous banner"
      >
        <ChevronLeft size={28} />
      </button>

      <button
        className="award-banners-button award-banners-button-next"
        onClick={scrollNext}
        aria-label="Next banner"
      >
        <ChevronRight size={28} />
      </button>
    </div>
  );
};

export default AwardBannersCarousel;